import { FC } from 'react'
import moment from 'moment'
import { Spinner } from 'react-bootstrap'
import { SalesPerformanceItems } from '../../../../../services/cellcast.type'
import { AuthenticateUser } from '../../../../Utils/_helpers/RoleAndPermission'
import { useDispatch } from 'react-redux'
import { ProfileDetailData } from '../../../../Redux/AdminPanel/ProfileDetailsSlice'
import { useNavigate } from 'react-router-dom'

interface Props {
  data: SalesPerformanceItems[]
  isLoading: boolean
  updateStatusUsedCoupon: (id: string, status: boolean) => Promise<void>
}

export const DashboardTable: FC<Props> = ({ data, isLoading, updateStatusUsedCoupon }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  return (
    <div className='card-body p-0 pt-1'>
      <div className='table-responsive'>
        <table className='table align-middle gs-0 gy-5'>
          <thead>
            <tr className='fw-bold text-muted'>
              <th>Account Name</th>
              <th>Coupon</th>
              <th>Purchase</th>
              <th>Commission</th>
              <th>Last Active</th>
              <th>Purchase Date</th>
              <th>Assigned Staff</th>
              <th>Feature Usage</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={11} className='text-center'>
                  <Spinner size='sm' animation='border' variant='primary' />
                </td>
              </tr>
            ) : (
              data.map((item, index) => (
                <tr key={index}>
                  <td>
                    {item?.name ? (
                      <span
                        onClick={() => {
                          if (AuthenticateUser('edit-user')) {
                            dispatch(ProfileDetailData(item?._id))
                            navigate(`/user-profile`)
                          }
                        }}
                        className='text-dark fw-bolder text-hover-primary fs-6 d-flex flex-column'
                      >
                        {item?.name}
                        <small className='text-muted'>{item.email}</small>
                      </span>
                    ) : <small className='text-muted'>Deleted User!</small>}
                  </td>
                  <td>
                    <div className='d-flex flex-column'>
                      {item.code}
                      <small className='text-muted'>Assigned: {moment(item.assignedAt).format('DD/MM/YYYY')}</small>
                      <small className='text-muted'>Expired: {moment(item.expiredAt).format('DD/MM/YYYY')}</small>
                      <small className='text-muted'>Commision: {item?.commisionRate} %</small>
                      <span
                        className={`badge ${item.couponStatus === 'expired'
                            ? 'badge-light-danger'
                            : item.couponStatus === 'applied'
                              ? 'badge-light-warning'
                              : 'badge-light-success'
                          }`}
                      >
                        {item.couponStatus?.toUpperCase()}
                      </span>
                    </div>
                  </td>
                  <td>${(item.totalAmountWithGST ?? 0).toFixed(3)}</td>
                  <td>${(item.commission ?? 0).toFixed(3)}</td>
                  <td>
                    <div className='d-flex flex-column'>
                      <small className='text-muted'>Last Login: {item.lastLogin ? moment(item.lastLogin).format('DD/MM/YYYY') : '-'}</small>
                      <small className='text-muted'>Last Send: {item.lastSend ? moment(item.lastSend).format('DD/MM/YYYY') : '-'}</small>
                      <small className='text-muted'>Note: {item?.notes}</small>
                    </div>
                  </td>
                  <td>
                    <div>{item.purchasedDate ? moment(item.purchasedDate).format('DD/MM/YYYY') : '-'}</div>
                  </td>
                  <td>{item.staffName}</td>
                  <td>
                    {item.features &&
                      item.features.map((feature, idx) => (
                        <span key={idx} className="badge badge-light-primary me-1">
                          {feature}
                        </span>
                      ))}
                  </td>
                  <td>
                    <span
                        className={`badge ${item.hasUsedCoupon ? 'badge-light-danger' : 'badge-light-success'
                          }`}
                      >
                        {item.hasUsedCoupon  ? 'Close' : 'Open'}
                      </span>
                  </td>
                  <td>
                    <button onClick={() => updateStatusUsedCoupon(item?._id, !item.hasUsedCoupon)} disabled={!item.hasUsedCoupon} className='btn btn-sm btn-light btn-active-light-primary'>
                      Reopen
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}